// src/services/subscriptionService.ts
import apiClient from "../api/apiClient";

const TENANT_ID = process.env.REACT_APP_TENANT_ID ?? "1";

export interface GrantSubscriptionDto {
    userId: number;
    subjectIds: number[];
    expiryDate: string; // ISO format preferred e.g. "2025-12-31T23:59:59Z"
}

/**
 * Manually grant a user access to specific subjects.
 * Endpoint: POST /api/subscriptions/admin/grant
 */
export async function grantSubscription(payload: GrantSubscriptionDto) {
    const resp = await apiClient.post("/subscriptions/admin/grant", payload, {
        params: { tenantId: TENANT_ID }
    });
    return resp.data;
}

export interface RevokeSubscriptionDto {
    userId: number;
    subjectIds: number[];
}

/**
 * Revoke (cancel) a user's access to specific subjects.
 * Endpoint: POST /api/subscriptions/admin/revoke
 */
export async function revokeSubscription(payload: RevokeSubscriptionDto) {
    const resp = await apiClient.post("/subscriptions/admin/revoke", payload, {
        params: { tenantId: TENANT_ID }
    });
    return resp.data;
}